/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Data transfer object for the M:WebApi.Services.Interfaces.IUserService.ConfirmResetPasswordAsync(System.String,System.String,System.String) response.
 * @export
 * @interface WebApiServicesDataTransferObjectsUserServiceParticipantDto
 */
export interface WebApiServicesDataTransferObjectsUserServiceParticipantDto {
    /**
     * Gets or sets the Name.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceParticipantDto
     */
    name?: string | null;
    /**
     * Gets or sets the Name.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceParticipantDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceParticipantDto
     */
    answer?: string | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsUserServiceParticipantDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsUserServiceParticipantDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsUserServiceParticipantDtoFromJSON(json: any): WebApiServicesDataTransferObjectsUserServiceParticipantDto {
    return WebApiServicesDataTransferObjectsUserServiceParticipantDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsUserServiceParticipantDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsUserServiceParticipantDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'answer': !exists(json, 'answer') ? undefined : json['answer'],
    };
}

export function WebApiServicesDataTransferObjectsUserServiceParticipantDtoToJSON(value?: WebApiServicesDataTransferObjectsUserServiceParticipantDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'email': value.email,
        'answer': value.answer,
    };
}

